/**
 * Rule that checks whether the diagram contains start/end nodes
 */
const { is } = require("bpmnlint-utils");

module.exports = function startEndRequired({ ctx }) {
  let evaluated = false;

  return {
    check(node, reporter) {
      if (!node) return;

      if (evaluated) return;
      evaluated = true;

      const registry = ctx && ctx.elementRegistry;
      const elements = registry && typeof registry.getAll === "function" ? registry.getAll() : [];

      let hasStart = false;
      let hasEnd = false;

      for (const el of elements) {
        if (!el) continue;

        const bo = el.businessObject || el;

        if (!bo) continue;

        if (is(bo, "bpmn:StartEvent")) {
          hasStart = true;
        } else if (is(bo, "bpmn:EndEvent")) {
          hasEnd = true;
        }

        if (hasStart && hasEnd) {
          break;
        }
      }

      let targetId = node.id;
      try {
        const modeler = ctx && ctx.modeler;
        const canvas = modeler && modeler.get && modeler.get("canvas");
        const root = canvas && canvas.getRootElement && canvas.getRootElement();
        if (root && root.id) {
          targetId = root.id;
        }
      } catch {}

      if (!hasStart) {
        reporter.report(targetId, "Diagram must contain at least one Start event.");
      }

      if (!hasEnd) {
        reporter.report(targetId, "Diagram must contain at least one End event.");
      }
    }
  };
};
